import { createGroupsCheckoutAPIClient } from '@/scopes/checkout/groups/infrastructure/api/groupsCheckoutAPIClient'

export const groupsCheckoutAPIClient = createGroupsCheckoutAPIClient({})
